import React from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import Header from '@/components/Filter/components/Header';
import ContentContainer from '@/components/ContentContainer';
import Button from '@/components/Button';
import {colors} from '@/constants/theme';
import {getFields} from '@/components/Filter/helpers';
import {FilterViewProps} from '@/typings/filter/types';

export const FilterView: React.VFC<FilterViewProps> = ({
                                                         fields,
                                                         values,
                                                         closeModal,
                                                         onChange,
                                                         onSubmit,
                                                         onReset,
                                                       }) => {
  const t = useTranslations();

  return (
    <Component>
      <Header onReset={onReset} closeModal={closeModal}/>
      <Main>
        <ContentContainer>
          {fields.map((field) => (
            <Field key={field.id}>
              <Label>{field.label}</Label>
              {getFields(field, values[field.id].data, onChange)}
            </Field>
          ))}
          <Footer>
            <StyledButton
              onClick={onSubmit}
              width="100%"
              variant="outlined-primary-w100-f13"
            >
              {t('filter.apply')}
            </StyledButton>
          </Footer>
        </ContentContainer>
      </Main>
    </Component>
  );
};

const Component = styled.div`
  position: relative;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background: white;
  height: calc(var(--vh, 1) * 100);
  width: 100vw;
`;

const Main = styled.div`
  position: relative;
`;
const StyledButton = styled(Button)``;
const Footer = styled.div`
  margin-top: 15px;
  background: ${colors.white};
  padding: 15px 0;
  position: sticky;
  bottom: 0;
  z-index: 1;
`;

const Field = styled.div`
  margin-top: 20px;
`;

const Label = styled.div`
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
`;
